// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1iSm8","consentsList":"PatientConsents_consentsList__1ti-j","consentsListEmpty":"PatientConsents_consentsListEmpty__ivL_8"};